const uri = process.env.REACT_APP_WEBHOOK_BASE_URL;

export const WEBHOOK_NAMES: Record<string, string> = {
  "change_column_value": "When any column value changes, send a webhook",
  "change_name": "When an item name changes, send a webhook",
  "create_update": "When a new update is posted, send a webhook",
  "delete_update": "When an update is deleted, send a webhook",
  "edit_update": "When an update changes, send a webhook",
  "item_deleted": "When an item is deleted, send a webhook",
  "change_subitem_column_value": "When any subitem column changes, send a webhook",
  "change_subitem_name": "When subitem name changes, send a webhook",
  "subitem_deleted": "When a subitem is deleted, send a webhook",
  "create_subitem_update": "When a new update is posted on a subitem, send a webhook",
  "item_moved_to_any_group": "When an item is moved to any group, send a webhook",
  "create_subitem": "When a subitem is created, send a webhook",
  "item_archived": "When an item is archived, send a webhook",
  "subitem_archived": "When a subitem is archived, send a webhook",
};
const webhookUriBase = `${uri}/simb/webhook`;

export const webhookEndpoints: Record<string, string> = {
  change_column_value: `${webhookUriBase}/change-column-value`,
  create_update: `${webhookUriBase}/updates`,
  change_name: `${webhookUriBase}`,
  delete_update: `${webhookUriBase}/updates`,
  edit_update: `${webhookUriBase}/edit-updates`,
  item_deleted: `${webhookUriBase}/item-deleted`,
  change_subitem_column_value: `${webhookUriBase}/change-subitem-column-value`,
  subitem_deleted: `${webhookUriBase}/subitem-deleted`,
  create_subitem_update: `${webhookUriBase}/create-subitem-update`,
  change_subitem_name: `${webhookUriBase}/change-subitem-name`,
  item_moved_to_any_group: `${webhookUriBase}/update-item`,
  create_subitem: `${webhookUriBase}/subitem-created`,
  item_archived: `${webhookUriBase}/item-archived`,
  subitem_archived: `${webhookUriBase}/subitem-archived`,
};
